import BasicImage from 'core/BasicImage';
import ScrollAnimation from 'core/ScrollAnimation';
import React from 'react';

import BannerCaseNav from '~/components/features/cases/NextComponents/cases-sections/BannerCase/BannerCaseNav';

import cn from './style.module.sass';

type BannerCaseProps = {
    img: string;
    isCase?: boolean;
    caseType?: string;
};

export default function BannerCase({ img, isCase, caseType }: BannerCaseProps) {
    return (
        <ScrollAnimation className={cn.bannerCase}>
            <div className={cn['bannerCase__wrapper']}>
                <BasicImage
                    src={img}
                    width={0}
                    height={0}
                    quality={85}
                    sizes="100vw"
                    alt={img}
                    className={cn['bannerCase__img']}
                />

                <BannerCaseNav caseType={caseType ? caseType : 'Маркетинг'} isCase={isCase} />
            </div>
        </ScrollAnimation>
    );
}
